import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import ForwardChatActions from "./widget/ForwardChatActions";
import ForwardChatButtons from "./widget/ForwardChatButtons";
import { ForwardChatContextProvider } from "../../../provider/chats/chats/forward_chat/ForwardChatContextProvider";
import ForwardChatContent from "./ForwardChatContent";

const ForwardChatScreen = (props: {
  screenMobileView: boolean;
  isMedia: boolean;
}) => {
  return (
    <ForwardChatContextProvider>
      {props.screenMobileView === true ? (
        <Scaffold
          appBarTitle={AppTranslation.text("forward")}
          appBarAction={<ForwardChatActions />}
          bottomNavigationButton={
            <ForwardChatButtons isMedia={props.isMedia} />
          }
          isModal={true}
        >
          <MainBodyContainer className="h-100">
            <ForwardChatContent isMedia={props.isMedia} />
          </MainBodyContainer>
        </Scaffold>
      ) : (
        <ForwardChatContent isMedia={props.isMedia} />
      )}
    </ForwardChatContextProvider>
  );
};

export default ForwardChatScreen;
//export const routeName: string = "/forward-chat";
